import { useEffect, useState } from "react";
import { getLocalStorageBaseUrl, getLocalStore } from "./localStorage";

const GetPrivateBucketMedia = ({
  image,
  alt = "media",
  className,
  loader = <p>Loading...</p>,
  fallback = <p>Image not available</p>,
}) => {
  const [imgUrl, setImgUrl] = useState("");
  const [error, setError] = useState(false);

  const getPrivateMedia = async (image) => {
    const token = getLocalStore()?.token;

    const res = await fetch(`${getLocalStorageBaseUrl()}/secure/media/${image}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) throw new Error("Failed to fetch");

    const blob = await res.blob();
    return URL.createObjectURL(blob);
  };

  useEffect(() => {
    let isMounted = true;
    // if (!image) return;

    async function loadImage() {
      try {
        const url = await getPrivateMedia(image);
        if (isMounted) setImgUrl(url);
      } catch (err) {
        console.error("Failed to load media:", err);
        if (isMounted) setError(true);
      }
    }

    loadImage();
    return () => {
      isMounted = false;
    };
  }, [image]);

  if (error) return <>{fallback}</>;
  if (!imgUrl) return <>{loader}</>;

  return <img src={imgUrl} alt={alt} className={className}  style={{
    objectFit : 'contain'
  }}/>;
};

export default GetPrivateBucketMedia;